import { render, staticRenderFns } from "./ImagePanel.vue?vue&type=template&id=2feb6fcc&scoped=true"
import script from "./ImagePanel.vue?vue&type=script&lang=js"
export * from "./ImagePanel.vue?vue&type=script&lang=js"
import style0 from "./ImagePanel.vue?vue&type=style&index=0&id=2feb6fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb6fcc",
  null
  
)

export default component.exports